import React from 'react';
import {
  BarChart as RechartsBarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import AnalyticsEmptyState from "../../dashboard/AnalyticsEmptyState";
import { CHART_MARK_STROKE, CHART_MARK_STROKE_WIDTH } from '../../../helpers/chartPalette';

const ParagraphMomentBarChart = ({ data, totalResponses, graphColor }) => {

  if (!(data?.[0]?.Categories?.length > 0)) {
    return <AnalyticsEmptyState />;
  }

  // Convert the Categories array into the format required for the bar chart
  const barData = data[0].Categories.map((category, index) => ({
    name: category?.Title || 'Untitled',
    value: category?.Words ?? 0,
    color: category?.Color || '#ccc',
    index: index + 1,
  }));

  // Custom tooltip content
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { name, value, color } = payload[0].payload;
      return (
        <div
          style={{
            backgroundColor: 'white',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '5px',
          }}
        >
          <p style={{ margin: 0, fontWeight: 'bold' }}>{name}</p>
          <p style={{ margin: 0, color }}>{`Value: ${value}`}</p>
        </div>
      );
    }
    return null;
  };

  // Custom legend
  const CustomLegend = ({ payload }) => {
    return (
      <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexWrap: 'wrap' }}>
        {payload.map((entry, index) => (
          <li
            key={`legend-item-${index}`}
            style={{ display: 'flex', alignItems: 'center', marginRight: 10, marginBottom: 5 }}
          >
            <div
              style={{
                width: 12,
                height: 12,
                backgroundColor: entry.color,
                marginRight: 8,
              }}
            ></div>
            <span style={{ color: graphColor || 'black' }}>{`${entry.payload.name} (${entry.payload.value})`}</span>
          </li>
        ))}
      </ul>
    );
  };

  const dummyData = [
    { name: 'Category 1', value: 10, color: 'lightgrey', index: 1 },
    { name: 'Category 2', value: 20, color: 'lightgrey', index: 2 },
    { name: 'Category 3', value: 30, color: 'lightgrey', index: 3 },
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: 1,
        minHeight: 0,
        width: '100%',
      }}
    >
      {barData.length > 0 ? (
        <>
          <ResponsiveContainer width="100%" height={300}>
            <RechartsBarChart data={barData}>
              <XAxis
                dataKey="index"
          stroke={graphColor || 'black'}
          tick={{ fill: graphColor || 'black' }}
          axisLine={false}
          tickLine={false}
          />
          <YAxis
           stroke={graphColor || 'black'}
          tick={{ fill: graphColor || 'black' }}
          axisLine={false}
          tickLine={false}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar
            dataKey="value"
            barSize={30}
         stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH}>
            {barData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
            ))}
          </Bar>
        </RechartsBarChart>
      </ResponsiveContainer>
      </>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
            <RechartsBarChart data={dummyData}>
              <XAxis
                dataKey="index"
                stroke={'lightgrey'}
                tick={false}
                axisLine={false}
                tickLine={false} 
                />
                <YAxis 
                stroke={'lightgrey'}
                tick={false}
                axisLine={false}
                tickLine={false} 
                />
                <Bar
                  dataKey="value"
                  barSize={30}
               stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH}>
              {dummyData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
                ))}
            </Bar>
          </RechartsBarChart>
        </ResponsiveContainer>
      )}
      <CustomLegend payload={barData.map((entry) => ({
        color: entry.color,
        payload: entry,
      }))} />
    </div>
  );
};

export default ParagraphMomentBarChart;
